import t from 'react-translate';
import { useSelector } from 'react-redux';
import { MentoringProgramEnrollment } from 'redux/schemas/models/mentoring-program-enrollments';
import { getMentoringProgramEnrollment } from 'redux/selectors/mentoring-program-enrollments';
import { ProgramLevelQuestionType } from 'redux/schemas/models/mentoring-program-profile-questions';
import { DEFAULT_CONCURRENT_MENTOR_CONNECTION } from 'athena/components/mentoring-program/constants';
import { config } from '@config/pendo.config.json';
import MentoringProgramContext from 'athena/components/mentoring-program/context';
import { useContext } from 'react';
import { getMentoringProgramAliases } from 'redux/selectors/mentoring-programs';
import Question from '../../question';

type MentorCapacityQuestionProps = {
  enrollmentId: number;
  maxMentees: number;
};

const CONCURRENT_MENTOR_CONNECTION_ID = 'concurrent_mentor_connection_setting';

const MentorCapacityQuestion = ({
  enrollmentId,
  maxMentees,
}: MentorCapacityQuestionProps) => {
  const mentorshipProgramEnrollment: MentoringProgramEnrollment = useSelector(
    (state) => getMentoringProgramEnrollment(state, enrollmentId),
  );
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const mentoringProgramAliases = useSelector((state) => getMentoringProgramAliases(state, mentoringProgram.id));
  const { concurrentMentorConnection } = mentorshipProgramEnrollment || {};
  const translationBase = t.MENTORING_PROGRAMS.PARTICIPANT_HOME.GET_STARTED.PROFILE_MODAL
    .PROGRAM_QUESTIONS.MENTOR_CAPACITY;

  const concurrentMenteesOptions = Array.from({ length: maxMentees }, (_, i) => (i + 1).toString());

  const dataQATag = config.pendo.athena.mentorshipProgram.participantHome.steps.profile
    .questions.mentorCapacity;

  const label = translationBase.TITLE(mentoringProgramAliases);

  return (
    <div>
      <Question
        isRequired
        id={CONCURRENT_MENTOR_CONNECTION_ID}
        type={ProgramLevelQuestionType.DROPDOWN}
        title={label}
        answer={`${
          concurrentMentorConnection || DEFAULT_CONCURRENT_MENTOR_CONNECTION
        }`}
        options={concurrentMenteesOptions}
        dataQa={dataQATag}
        dataQaId={`${dataQATag}-${enrollmentId}`}
        ariaLabel={label}
        renderFallbackValue
      />
      <div className='text-small semi-bold gray-2'>
        {translationBase.NOTE()}
      </div>
    </div>
  );
};

export default MentorCapacityQuestion;
